import {
  SUPERADMIN_ALL_OFFER_LIST,
  UPDATE_ADMIN_OFFER_STATUS,
  SUPERADMIN_DELETE_OFFER,
  SUPERADMIN_RESTAURANT_OFFER_LIST,
  GET_OFFER_DETAIL_FROM_ID,
  UPDATE_CAROUSEL_RESTAURANT_OFFER,
  SUPERADMIN_RESTAURANT_DELETE_OFFER,
} from "../../types";

const initialState = {
  allSuperAdminOffers: [],
  allRestaurantAdminOffers: [],
  restaurantDetailFromOfferId: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SUPERADMIN_ALL_OFFER_LIST:
      return {
        ...state,
        allSuperAdminOffers: payload,
      };

    case UPDATE_ADMIN_OFFER_STATUS:
      var updateAdminOfferActive = state.allSuperAdminOffers.map((offer) => {
        if (offer._id === payload._id) {
          return {
            ...payload,
          };
        } else {
          return offer;
        }
      });
      return {
        ...state,
        allSuperAdminOffers: updateAdminOfferActive,
      };

    case SUPERADMIN_DELETE_OFFER:
      const deleteAdminOffer = state.allSuperAdminOffers.filter((offer) => {
        return offer._id !== payload;
      });
      return {
        ...state,
        allSuperAdminOffers: deleteAdminOffer,
      };
    case SUPERADMIN_RESTAURANT_OFFER_LIST:
      return {
        ...state,
        allRestaurantAdminOffers: payload,
      };
    case GET_OFFER_DETAIL_FROM_ID:
      return {
        ...state,
        restaurantDetailFromOfferId: payload,
      };

    case SUPERADMIN_RESTAURANT_DELETE_OFFER:
      const deleteOffer = state.allRestaurantAdminOffers.filter((offer) => {
        return offer._id !== payload;
      });
      return {
        ...state,
        allRestaurantAdminOffers: deleteOffer,
      };

    case UPDATE_CAROUSEL_RESTAURANT_OFFER:
      var updatedStatusData = state.allRestaurantAdminOffers.map((offer) => {
        if (offer._id === payload._id) {
          return {
            ...payload,
          };
        } else {
          return offer;
        }
      });
      return {
        ...state,
        allRestaurantAdminOffers: updatedStatusData,
      };

    default:
      return state;
  }
}
